import React from 'react';

import { Typography } from '@mui/material';

import { getOptionTypeName } from 'utils/data';
import { formatNumberToFixed2DecimalsExceptNull } from 'utils/number';

import ActionButton from './ActionButton';
import { defaultSortOrder, TableColumnId } from './PropertyTaxes.constants';

export const getTableConfig = ({
  propertyTaxTypeOptions,
  setEditableData,
  deleteTableData,
  editableRowId,
  isActionDisabled,
}) => ({
  [TableColumnId.IMPOUND_TYPE_ID]: {
    label: 'Type',
    width: '45%',
    sort: true,
    sortBy: defaultSortOrder.id,
    colSpan: ({ impoundTypeId }) => impoundTypeId?.colSpan,
    customStyles: ({ impoundTypeId }) => impoundTypeId?.customStyles,
    content: ({ impoundTypeId }) =>
      impoundTypeId?.content ?? (
        <Typography data-truncated className="truncate" variant="regular14">
          {getOptionTypeName(propertyTaxTypeOptions, impoundTypeId)}
        </Typography>
      ),
  },
  [TableColumnId.MONTHLY_AMOUNT]: {
    label: 'Monthly Amount',
    sort: true,
    width: '45%',
    content: ({ monthlyAmount }) => (
      <Typography data-truncated className="truncate" variant="regular14">
        {monthlyAmount ? `$${formatNumberToFixed2DecimalsExceptNull(Number(monthlyAmount))}` : ''}
      </Typography>
    ),
  },
  action: {
    label: 'Action',
    width: '10%',
    content: rowData => (
      <ActionButton
        deleteTableData={deleteTableData}
        isDisabled={isActionDisabled || (!!editableRowId && rowData.id !== editableRowId)}
        isEditDisabled={rowData.id === editableRowId}
        rowData={rowData}
        setEditableData={setEditableData}
      />
    ),
    align: 'center',
  },
});
